module.exports = __webpack_public_path__ + "static/img/10areaA_07.a365068.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/10areaA_07.png
// module id = 794
// module chunks = 1